<template>
  <label
    :for="id"
    class="custom-checkbox group relative flex cursor-pointer select-none items-center pl-9"
    data-testid="checkbox-label"
    :class="{
      'font-medium': isActive,
      'text-sm': textSize === 'sm',
      'text-lg': textSize === 'lg',
      'text-xl': textSize === 'xl',
      'text-2xl': textSize === '2xl',
    }"
  >
    <input
      :id="id"
      v-model="selected"
      :value="item"
      type="checkbox"
      class="peer sr-only"
      :aria-label="label"
      :data-testid="inputDataTestId"
    />
    <span
      class="checkmark absolute left-0 size-6 border border-neutral-30 bg-white peer-focus-visible:outline"
      aria-hidden="true"
    />
    <span class="flex items-center" :class="{ 'font-medium': isActive }">
      <slot name="icon" />
      <slot name="label">
        <span class="tabular-nums">{{ label }}</span>
      </slot>
    </span>
  </label>
</template>

<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Array as PropType<object[]>,
    default: () => [],
  },
  item: {
    type: Object as PropType<object>,
    default: undefined,
  },
  id: {
    type: String as PropType<string>,
    required: true,
  },
  label: {
    type: String as PropType<string>,
    default: undefined,
  },
  textSize: {
    type: String as PropType<'sm' | 'md' | 'lg' | 'xl' | '2xl'>,
    default: 'sm',
  },
  inputDataTestId: {
    type: String as PropType<string>,
    default: undefined,
  },
})

const emit = defineEmits(['update:model-value'])

const selected = computed({
  get: () => props.modelValue as object[],
  set: (newValue: object[]) => emit('update:model-value', newValue),
})

const isActive = computed(
  () => selected.value.findIndex((i: object) => i === props.item) !== -1,
)
</script>
